export const DEFAULT_COLUMN_WIDTH = 180;
export const MIN_COLUMN_WIDTH = 80;
export const MAX_SMART_COLUMN_WIDTH = 360;
export const CELL_HORIZONTAL_PADDING = 32;
export const AVERAGE_CHARACTER_WIDTH = 8;
export const DEFAULT_ROW_HEIGHT = 64;
export const FORMULA_ERROR = "#ERROR";
export const ROW_HEADER_WIDTH = 44;

export type CellType = "header" | "cell";
export type CellAlign = "left" | "center" | "right";
export type CellDirection = "ltr" | "rtl";
export type Coord = { row: number; col: number };
export type SelectionState = { start: Coord; end: Coord };

export type TableCellModel = {
  id: string;
  text: string;
  type: CellType;
  rowspan: number;
  colspan: number;
  hidden: boolean;
  bold: boolean;
  italic: boolean;
  align: CellAlign;
  direction: CellDirection;
};

export type ResizingState = {
  colIndex: number;
  startX: number;
  startWidth: number;
} | null;
